import React from "react";
import Dialog from '@material-ui/core/Dialog';
import t from '../../../../helpers/t';
import { moment } from "../../../../../../vendor";
import {_exchangeLabel} from "../../../../../utils/Helper";
import {dateFormat} from "../../../../../utils/FormatHelper";
import * as OrderFunctions from "../../../reservations/components/behaviors/OrderFunctions";

const CheckinsDialog = (props) => {
    const { checkins,setCheckins, handleCloseDialog, dispatch, getUsernameById, resource, currentUrl, language } = props;
    const checkout = (e,checkin) => {
        window.location.replace("/reservations/reservationsList?checkout=true&order_nbr="+checkin.reservation.order.order_nbr+'&returnUrl='+currentUrl);
    }
    return (
        <>
            <Dialog
                    onClose={handleCloseDialog}
                    aria-labelledby="changelogs-dialog-title"
                    open={true}
                    name="resourceDefectsDialog"
                    id="resourceDefectsDialog"
                    maxWidth={"ld"}
                >
                <header className="inb-multiple-recipients-header" style={{padding:"10px"}}>
                    <button
                        onClick={handleCloseDialog}
                        type="button"
                        id="inb-multiple-recipients-dialog-close-button"
                        className="button hollow secondary right button-close-multiple-recipients-dialog round"
                        title={t("close checkins")}
                    >
                        <i className="fi fi-x"></i>
                    </button>
                        <h4>{t('checkins', null, 'capital')} {resource.name}</h4>
                    <h4 style={{paddingTop:"10px"}}>{t('The')} {t('resource',null,'capital')} {t('is actually in a rent, please check it out.')}</h4>
                        {typeof checkins !== 'undefined' && checkins.length > 0 &&
                            <div id="inb-c-main-header">
                                <ul className="inb-tabs row hide-for-small-only">
                                    <li className="tabs-title column medium-2">{t('date',null,'capital')}</li>
                                    <li className="tabs-title column medium-2">{t('order_nbr',null,'capital')}</li>
                                    <li className="tabs-title column medium-2">{t('description',null,'capital')}</li>
                                    <li className="tabs-title column medium-2">{t(_exchangeLabel('location_of_checkin'),null,'capital')}</li>
                                    <li className="tabs-title column medium-2">{t('status',null,'capital')}</li>
                                    <li className="tabs-title column medium-2">&nbsp;</li>
                                </ul>
                            </div>
                        }
                    </header>

                    {/* <label className="inb-form__controlLabel legendLabel"><a href="#"
                                                                        onClick={(e) => _showPopUp(e, 'voucher for temporary user')}><i
                className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i></a></label>*/}
               <div id="inb-c">
<div className="off-canvas-wrapper">
                <div id="inb-c-main-multiple-recipients" className="inb-c-listing off-canvas-content" data-off-canvas-content="" style={{paddingBottom:"20px"}}>
                    {typeof checkins !== 'undefined' && checkins.length > 0 ? checkins.map((checkin, index) => {
                            let endReserv = (checkin.reservation.end !== null && moment(checkin.reservation.end).format(dateFormat(language)) !== moment(checkin.reservation.begin).format(dateFormat(language)));
                            return (<>
                                <div className="inb-c-item inb-c-item--recipient row" key={index}>
                                    <div className="large-2 medium-2 small-12 column show-label" title={t('date',null,'capital')}>
                                        {!endReserv ? <><span>{moment(checkin.reservation.begin).format(dateFormat(language,true))}</span></> :<><span>
                                        {moment(checkin.reservation.begin).format(dateFormat(language,true))} </span><br/><span className="show-for-small-only" style={{padding:"0 5px"}}> - </span>
                                        <span>{moment(checkin.reservation.end).format(dateFormat(language,true))}</span></>
                                        }
                                    </div>
                                    <div className="large-2 medium-2 small-12 column show-label" title={t('order_nbr',null,'capital')}>
                                        <span>{checkin.reservation.order.order_nbr }</span>
                                    </div>
                                    <div className={"large-2 medium-2 small-12 column show-label"} title={t('description',null,'capital')}>
                                        <span>{OrderFunctions.getOrderUsername(checkin.reservation.order)}</span>
                                        <br/>
                                        <span className={"show-for-large-only"}>{OrderFunctions.printReservationContingentsAmountList(checkin.reservation, false)}</span>
                                    </div>
                                    <div className={"large-2 medium-2 small-12 column show-for-small-only"}>
                                        <span>{OrderFunctions.printReservationContingentsAmountList(checkin.reservation, false)}</span>
                                    </div>
                                    <div className={"large-2 medium-2 small-12 column show-label"} title={t(_exchangeLabel('location_of_checkin'),null,'capital')}>
                                        <span>{t('location_of_checkin', null, 'capital')+': '+checkin.reservation.begin_location_name}</span>
                                    </div>
                                    <div className={"large-2 medium-2 small-12 column show-label"} title={t('status')}>
                                        <span>{t(checkin.reservation.status)}</span>
                                    </div>
                                    <div className="large-2 medium-2 small-12 column show-label" title={t('checkout_reservation', null, 'capital')}>
                                        <a href = "#" onClick={(e) => {checkout(e,checkin)}}>{t('checkout_reservation', null, 'capital')}</a>
                                    </div>
                                </div>
                            </>)
                        }):
                        <>
                            <div
                                id="inb-app-collection-empty"
                                className="inb-announcement">
                                <div className="inb-image-box">
                                    <img src="assets/img/no_data.svg"/>
                                </div>
                                <h3>
                                    { t('app_msg_collection_empty') }
                                </h3>
                                <p>
                                    { t('app_msg_collection_empty_body') }
                                </p>
                            </div>
                        </>
                    }
                </div>
               </div>
               </div>
            </Dialog>
        </>
    );
}

export default CheckinsDialog;